import type { FC, ReactNode } from 'react';
import { cn } from './react';

export type WidgetProps = {
  className?: string;
  children?: ReactNode;
  loading?: boolean;
};

export const Widget: FC<WidgetProps> = ({ className, children, loading }) => (
  <section
    className={cn(
      'border border-border-disabled p-widget rounded-xl',
      'overflow-auto scrollbar-none',
      loading && 'shimmer',
      className,
    )}
  >
    {children}
  </section>
);
